import { getErrorMessage } from '../util/ErrorUtils';
import axios from '../util/axiosConfig';

export const fetchPracticeMachinesAPI = async (practiceId) => {
    return await axios.get(`/api/v1/mips/${practiceId}/machines`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchPracticeUsersAPI = async (practiceId) => {
    return await axios.get(`/api/v1/practice/${practiceId}/users`)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}


export const fetchRosterAPI = async ({ practiceId, date }) => {
    return await axios.get(`/api/v1/practice/${practiceId}/roster`, {
        params: {
            "date": date
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const addUpdateRosterEventAPI = async (event) => {
    return await axios.post(`/api/v1/add-update-roster-event`, event)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const deleteRosterEventAPI = async (timeslotId) => {
    return await axios.delete(`/api/v1/roster`, {
        params: {
            "timeslotId": timeslotId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const addRosterRecurringEventsAPI = async (recurringEvents) => {
    return await axios.post(`/api/v1/roster/recurring-events`, recurringEvents)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}